import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Storage helpers — encapsulated to ease swapping for httpOnly cookies later.
// NOTE: JWT is currently stored in localStorage which is XSS-readable. We
// mitigate by (a) short token lifetime (7d), (b) strict CSP/CORS, and (c) the
// Google OAuth path uses httpOnly cookies. A future migration would move
// email/password sessions to httpOnly cookies as well.
// localStorage can throw in privacy modes / sandboxed iframes — fail silent
// in prod, log in dev so we still surface real issues during development.
const _devWarn = (label, err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[tokenStore] ${label}:`, err?.message || err);
  }
};
export const tokenStore = {
  get() { try { return localStorage.getItem("lokaso_token"); } catch (e) { _devWarn("get failed", e); return null; } },
  set(t) { try { localStorage.setItem("lokaso_token", t); } catch (e) { _devWarn("set failed", e); } },
  clear() { try { localStorage.removeItem("lokaso_token"); } catch (e) { _devWarn("clear failed", e); } },
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401s are expected for auth probes; pass them through without log noise.
const QUIET_401_PATHS = ["/auth/me", "/favorites/ids"];
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && QUIET_401_PATHS.some((p) => url.includes(p))) {
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);

export default api;
